import '../styles/secondary-links.scss'
import type { FC } from 'react'
import { Link } from 'react-router-dom-v7'
import { cmsDataService } from '@/common/services/cms.data.service'

export const SecondaryLinks: FC = () => {
    const secondaryLinks = cmsDataService.get().footer.secondaryLinks

    return (
        <div className="footer-secondary-links">
            {secondaryLinks.map((group, index) => (
                <div key={index}>
                    {group.title && <h5>{group.title}</h5>}
                    <ul>
                        {group.links.map((link, linkIndex) => (
                            <li key={linkIndex}>
                                <Link to={link.url} target={link.target}>
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    )
}
